<template>
  <div class="tw-flex tw-items-center tw-gap-3 tw-h-[40px]">
    <WdsToggle
      :id="computedId"
      :checked="modelValue"
      @update:checked="$emit('update:modelValue', $event)"
    />
    <div class="tw-flex tw-items-center tw-gap-2 tw-flex-grow tw-pt-[3px]">
      <label :for="computedId" class="tw-text-base tw-mb-0 tw-whitespace-nowrap">
        {{ label }}
      </label>
      <WdsTooltip v-if="helpInfo !== ''" :text="helpInfo">
        <WdsIcon name="info-filled" :size="14" color="#9999AA" />
      </WdsTooltip>
    </div>
    <NetworkLoader :loader="loading" :failed="failed" size="sm" />
  </div>
</template>

<script>
import { WdsToggle, WdsTooltip, WdsIcon } from '@worksome/wds-components'
import NetworkLoader from '@/components/NetworkLoader.vue'
import { btoaSafe } from '@/components/GraphqlDataTable/filters/filter-tools'

/**
 * Note: due to the hashing generation of id, these props can never be identical between usages
 */
export default {
  components: {
    WdsToggle,
    WdsTooltip,
    WdsIcon,
    NetworkLoader,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    helpInfo: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    failed: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    showNetworkLoader() {
      return this.loading || this.failed
    },
    computedId() {
      return this.id || `settings-option-${btoaSafe(JSON.stringify(this.$props))}`
    },
  },
}
</script>
